import type { UrlObject } from 'url';

export const isUrlObject = (url: any): url is UrlObject => {
  return !!url?.pathname;
};
